<label
  class="transition-all ease-in-out duration-300 inline-flex"
  [ngClass]="disabled ? 'cursor-not-allowed opacity-50' : 'cursor-pointer'"
>
  <input
    type="checkbox"
    class="sr-only"
    [name]="name"
    [attr.aria-label]="ariaLabel"
    [attr.aria-checked]="checked"
    [attr.id]="id"
    [checked]="checked"
    [disabled]="disabled"
    (change)="toggle(); onBlur()"
    role="switch"
  >
  <!-- Toggle track — shows focus ring when the hidden input is focused -->
  <div
    class="w-14 h-7 rounded-full border p-[3px] relative transition-colors ease-in-out duration-300 toggle-track"
    [ngClass]="checked ? 'bg-theme-green border-theme-green' : 'bg-gray-100 dark:bg-dark-hover border-gray-200'"
  >
    <!-- Thumb slider -->
    <div
      class="w-5 h-5 rounded-full transition-all ease-in-out duration-300"
      [ngClass]="checked ? 'translate-x-7 bg-white' : 'translate-x-0 bg-gray-400'"
    ></div>
  </div>
</label>
